// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 125 ? "component---src-pages-404-js" : chunkId) + "-" + {"70":"fc2049916de5fe20b313","125":"c7ab155412fdd1ac4fce","242":"0217047e6fff17831f45","556":"15932b040ef92b05468f"}[chunkId] + ".js";
};